import React, { useState, useEffect } from "react"

import { navigate } from "gatsby"

import { Modal } from "../modal/modal"
import { isBrowser } from "../../../helpers/helpers"

export const SurveyPopup = () => {
  const [isPopupActive, setIsPopupActive] = useState(false)
  const twominutes = 120000

  useEffect(() => {
    if (
      isBrowser 
    ) {
      setTimeout(openPopup, twominutes)
    }
  }, [])

  const openPopup = () => {
    setIsPopupActive(true)
  }

  const closePopup = () => {
    setIsPopupActive(false)
        
    if (isBrowser) {
        localStorage.setItem("isSurveyDismissed", "true")
    }
  }

  const closePopupAndRedirectSurvey = () => {
    closePopup()
    navigate("https://feedback.moneyadvicetrust.org/BDLwebsitesurvey")
  }


  return (
    <Modal
      title={{ label: "We welcome your feedback" }}
      isActive={isPopupActive}
      onClose={closePopup}
      buttons={[
        {
          id: "survey-popup",
          variant: "secondary",
          label: "Complete survey",
          ariaLabel: "Complete survey",
          className: "mt-2",
          onClick: closePopupAndRedirectSurvey,
        },
      ]}
    >
      <p>Help us improve your experience by taking our short survey.

      </p>

      <hr />
    </Modal>
  )
}
